import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// creates a beautiful scrollbar
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import MapaLeito from 'views/MapaLeito/MapaLeito';

import Navbar from 'components/Navbars/Navbar.js';
import Footer from 'components/Footer/Footer.js';
import Sidebar from 'components/Sidebar/Sidebar.js';
import FixedPlugin from 'components/FixedPlugin/FixedPlugin.js';

import routes from 'routes.js';

import styles from 'assets/jss/material-dashboard-react/layouts/adminStyle.js';

import bgImage from 'assets/img/sidebar-2.jpg';
import logo from 'assets/img/hcfamemalogo3.png';

import { PrivateRoute, getRedirectPath } from '../authentication';

let ps;

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState('blue');
  const [fixedClasses, setFixedClasses] = React.useState('dropdown show');
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === 'dropdown') {
      setFixedClasses('dropdown show');
    } else {
      setFixedClasses('dropdown');
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== '/admin/maps';
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  const [profissional, setProfissional] = React.useState(() => {
    try {
      const stored = localStorage.getItem('profissional');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (profissional) {
      if (navigator.platform.indexOf('Win') > -1) {
        ps = new PerfectScrollbar(mainPanel.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
        document.body.style.overflow = 'hidden';
      }
      window.addEventListener('resize', resizeFunction);
    }
    // Specify how to clean up after this effect:
    return () => {
      if (navigator.platform.indexOf('Win') > -1 && ps) {
        ps.destroy();
      }
      window.removeEventListener('resize', resizeFunction);
    };
  }, [profissional, mainPanel]);

  if (!profissional) return <Redirect from="/" to="/auth/login" />;

  const filteredRoutes = routes.filter(route => {
    if (route.requirePermissao && !profissional?.permissaoRelatorioNIR) {
      return false;
    }
    return true;
  });

  const switchRoutes = (
    <Switch>
      {filteredRoutes.map((prop, key) => {
        if (prop.layout === '/admin') {
          return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
        }
        return null;
      })}
      <PrivateRoute exact path="/admin/mapaLeito" component={MapaLeito} />
      <Redirect from="/admin" to={getRedirectPath()} />
    </Switch>
  );

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={filteredRoutes}
        logoText="LEAN"
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar routes={filteredRoutes} handleDrawerToggle={handleDrawerToggle} {...rest} />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        />
      </div>
    </div>
  );
}
